import { createFileRoute } from '@tanstack/react-router'

import { objectiveFiltersSchema } from '@/modules/objective/core/objective.schema'
import { ObjectivesToFinalizePage } from '@/modules/objective/presentation/pages/ObjectivesToFinalize'

export const Route = createFileRoute('/_authenticated/objectives/to-finalize')({
  component: ObjectivesToFinalizePage,
  head: () => ({
    meta: [
      {
        title: 'Objectives to finalize',
      },
    ],
  }),
  validateSearch: objectiveFiltersSchema,
})
